/**
 * Accordion module provided for managing accordion items
 */

 function closeAll() {
    let accordions = [...document.querySelectorAll('[data-accordion]')];

    for(let i=0; i <= accordions.length - 1; i++){
        const accordion = accordions[i];
        const content = accordion.querySelector("[data-accordion-content]");
        const indicatorOpened = accordion.querySelector("[data-accordion-indicator-opened]");
        const indicatorClosed = accordion.querySelector("[data-accordion-indicator-closed]");
        accordion.dataset.isOpen = 0;
        content.style.display = "none";
        indicatorOpened.style.display = "none";
        indicatorClosed.style.display = "";
    }
}

 const defaults = {
  event: 'click',

  selectors: {
      title: "[data-accordion-title]",
      content: "[data-accordion-content]",
      indicatorOpened: "[data-accordion-indicator-opened]",
      indicatorClosed: "[data-accordion-indicator-closed]",
  },
};
/**
* Accordion class provided for managing accordion
*/
class Accordion {
  /**
   * Accordion constructor.
   *
   * @returns {Promise}
   */
  constructor(element, options) {
      this.element = element;
      this.options = Object.assign({}, defaults, options);
  }

  /**
   * Execute scripts.
   *
   * @returns {void}
   */
  run() {
      this.init();
      this.bindEvents();
  }

  /**
   * Init scripts.
   *
   * @returns {void}
   */
  init() {
      this.title = this.element.querySelector(this.options.selectors.title);
      this.content = this.element.querySelector(this.options.selectors.content);
      this.indicatorOpened = this.element.querySelector(this.options.selectors.indicatorOpened);
      this.indicatorClosed = this.element.querySelector(this.options.selectors.indicatorClosed);

      this.close();
  }

  bindEvents() {
        if (this.options.event == 'click'){
            this.title.addEventListener("click", (e) => {

                const isOpenBeforeCloseAll = parseInt(this.element.dataset.isOpen);
            
                e.preventDefault();
                closeAll();

                if(!isOpenBeforeCloseAll) {
                    this.open();
                } else {
                    this.close();
                }
            });
        }

        if (this.options.event == 'hover'){
 
                this.element.addEventListener("mouseenter", (e) => {
                    e.preventDefault();
                    this.open();
                });
               
                this.element.addEventListener("mouseleave", (e) => {
                    e.preventDefault();
                    this.close()
                });
        }

  }

  open() {
      this.element.dataset.isOpen = 1;
 

      this.content.style.display = "";
      this.indicatorClosed.style.display = "none";
      this.indicatorOpened.style.display = "";
  }

  close() {
      this.element.dataset.isOpen = 0;

      this.content.style.display = "none";
      
      this.indicatorClosed.style.display = "";
      this.indicatorOpened.style.display = "none";
  }

  toggle() {
      const isOpen = parseInt(this.element.dataset.isOpen);
      if (!isOpen) {
          this.open();
      } else {
          this.close();
      }
  }

}

export default Accordion;